import React, { memo, useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import CRMTopPanel from './top-panel/TopPanel';
import useMenu from 'hooks/useMenu';
import WidgetAddModal from './WidgetAddModal';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useSearch from 'hooks/useSearch';
import Widget from './Widget';

export default memo(function Dashboard() {
  const { hasChild } = useMenu();
  const axiosPrivate = useAxiosPrivate();
  const query = useSearch();
  const view = (code) => hasChild('CRM', code);
  const [open, setOpen] = useState(false);

  const [hasError, setHasError] = useState(false);
  const [items, setItems] = useState([]);

  const { data: widgets, refetch } = useQuery({
    queryKey: ['/admin/widgets/widgets/{dashboard}', query.get('dashboard')],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/admin/widgets/widgets/${query.get('dashboard')}`
      );
      return response.data.data;
    },
    enabled: !hasError && !!query.get('dashboard'),
    onSuccess: (data) => {},
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  // Widgetlarni lokal holatga ko'chiramiz — drag bilan tartibini o'zgartirish uchun
  useEffect(() => {
    setItems(Array.isArray(widgets) ? widgets : []);
  }, [widgets]);

  const onDragEnd = (result) => {
    if (!result?.destination) return;
    if (result.destination.index === result.source.index) return;

    const arr = Array.from(items);
    const [moved] = arr.splice(result.source.index, 1);
    arr.splice(result.destination.index, 0, moved);
    setItems(arr);

    // Yangi tartibni bazaga saqlaymiz
    axiosPrivate
      .post(
        '/admin/widgets/reorder',
        JSON.stringify({
          widgets: arr.map((w, i) => ({ id: w?.id, position: i })),
        }),
        { headers: { 'Content-Type': 'application/json' } }
      )
      .catch(() => {});
  };

  return (
    <div className='h-full'>
      <CRMTopPanel
        addBlock={view('CRM_ADD_BLOCK')}
        setOpenWidgetModal={setOpen}
      />
      {open && (
        <WidgetAddModal open={open} setOpen={setOpen} refetchFn={refetch} />
      )}

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId='dashboard-widgets' direction='horizontal'>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className='h-[calc(100%-60px)] grid grid-cols-4 gap-3 pt-2 overflow-y-auto my-scroll'
            >
              {items.map((widget, index) => (
                <Draggable
                  key={widget?.id}
                  draggableId={String(widget?.id)}
                  index={index}
                >
                  {(prov) => (
                    <div
                      ref={prov.innerRef}
                      {...prov.draggableProps}
                      className='grid-item'
                    >
                      <Widget
                        info={widget}
                        refetch={refetch}
                        dragHandleProps={prov.dragHandleProps}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
});
